export default __webpack_public_path__ + "static/media/2866.95dbec95.png";